import { InputCurrency } from "@sellar-io/components";
import type { PriceListListResponseType } from "@sellar-io/api-v2/types";
import { twMerge } from "tailwind-merge";
import { InputContainer } from "@sellar-io/components";
import {
  TableLegacyTR,
  TableLegacyTD,
} from "../../../../components/table/TableLegacy";
import { usePriceFormat } from "../../../../hooks/usePriceFormat";
import { priceListItemsType } from "./ProductItemDialogPricing";

const handleUpdateItems = (
  priceListItems: priceListItemsType | undefined,
  ProductId: number,
  PriceListId: number,
  price: number,
) => {
  if (price < 0) return priceListItems;

  const item = {
    ProductId,
    basePrice: null,
    price,
    PriceListId,
    active: true,
    discountable: true,
  };

  if (!priceListItems?.length) return [item];

  const filteredPriceListItems = priceListItems.filter(
    (item) => item.PriceListId !== PriceListId,
  );

  if (price > 0) {
    filteredPriceListItems.push(item);
  }

  return filteredPriceListItems;
};
export default function ProductItemDialogPricingTableRow({
  priceList,
  productId,
  updatedPriceListItems,
  setUpdatedPriceListItems,
  warning,
}: {
  productId: number;
  priceList: PriceListListResponseType[number];
  setUpdatedPriceListItems: (item: priceListItemsType | undefined) => void;
  updatedPriceListItems: priceListItemsType | undefined;
  warning: boolean;
}) {
  const priceFormat = usePriceFormat();

  return (
    <TableLegacyTR>
      <TableLegacyTD>{priceList.name}</TableLegacyTD>
      <TableLegacyTD>
        <InputContainer
          className={twMerge(
            "w-[16ch]",
            warning &&
              !updatedPriceListItems?.length &&
              "shadow-[0_0px_8px_0_rgba(249,115,22,0.75)]",
          )}
        >
          <InputCurrency
            showPrefix
            allowNegative
            placeholder="No price"
            value={priceFormat.inputFormat}
            onChange={(e) => {
              priceFormat.setInputFormat(e.target.value);
              setUpdatedPriceListItems(
                handleUpdateItems(
                  updatedPriceListItems,
                  productId,
                  priceList.id,
                  parseFloat(e.target.value) * 100,
                ),
              );
            }}
          />
        </InputContainer>
      </TableLegacyTD>
    </TableLegacyTR>
  );
}
